import { PortableTextProjection, StringProjection } from '@lib/sanity/types/common';
import { isPortableText } from '@utils/validations';
import PortableText from './PortableText';
import Text from './Text';
import { SharedTextProps } from './constants';

export { TextVariant } from './constants';

type GenericTextProps = SharedTextProps & {
  content?: PortableTextProjection | StringProjection;
};

export default function GenericText({ content, ...props }: GenericTextProps) {
  if (!content?.value) {
    return null;
  }

  if (isPortableText(content as PortableTextProjection)) {
    return <PortableText content={content as PortableTextProjection} {...props} />;
  }

  return <Text content={(content as StringProjection)?.value} {...props} />;
}
